export default "__VITE_ASSET__pasBCa1T__"